import React from 'react';

const AWS_RDS = () => {
  return (
    <div>
      <h1>AWS_RDS</h1>
      <p>This is the AWS_RDS component.</p>
    </div>
  );
};

export default AWS_RDS;
